import styled from "styled-components";
import { cond, get, propEq, stubTrue } from "lodash/fp";
import { borderRadius, rgba } from "polished";
const PillWrapper = styled("div")(({ theme }) => ({
  alignItems: "stretch",
  color: theme.color.default,
  display: "inline-flex",
  flex: "0 0 auto",
  fontFamily: theme.fontFamily.default,
  fontSize: theme.fontSize.default,
  fontWeight: theme.fontWeight.normal,
  lineHeight: theme.lineHeight.default,
  maxWidth: "100%",
  minWidth: 0,
  transformStyle: "preserve-3d",
  whiteSpace: "nowrap"
}));
const PillButton = styled("div").attrs(({ $clickable }) => ({
  tabIndex: $clickable ? 0 : void 0,
  type: $clickable ? "button" : void 0
}))(
  ({ theme }) => ({
    alignItems: "center",
    backgroundColor: theme.color.gray3,
    border: `1px solid ${theme.controlBorderColor}`,
    borderRadius: 2,
    boxSizing: "border-box",
    color: "inherit",
    display: "flex",
    font: "inherit",
    margin: 0,
    outline: 0,
    overflow: "hidden",
    padding: 0,
    textOverflow: "ellipsis",
    "&::-moz-focus-inner": {
      border: 0
    }
  }),
  ({ $appearance, theme }) => ({
    active: {
      backgroundColor: theme.color.green1,
      borderColor: theme.color.green3
    },
    danger: {
      backgroundColor: theme.color.red1,
      borderColor: theme.color.red3
    },
    error: {
      backgroundColor: theme.color.red1,
      borderColor: theme.color.red3,
      color: theme.color.red6
    },
    warning: {
      backgroundColor: theme.color.yellow1,
      borderColor: theme.color.yellow3
    }
  })[$appearance],
  ({ $magnitude }) => ({
    lineHeight: $magnitude === "small" ? "18px" : void 0
  }),
  ({ $magnitude, $square }) => $square ? {
    justifyContent: "center",
    width: {
      small: 20,
      medium: 24
    }[$magnitude]
  } : {
    padding: {
      small: "0 4px",
      medium: "1px 8px"
    }[$magnitude]
  },
  ({ $clickable }) => $clickable ? {
    cursor: "pointer"
  } : void 0,
  ({ $adjoin }) => ({
    left: {
      borderRight: 0,
      ...borderRadius("right", 0)
    },
    right: {
      borderLeft: 0,
      ...borderRadius("left", 0)
    }
  })[$adjoin],
  cond([
    [
      get("$clickable"),
      cond([
        [
          propEq("$appearance", "active"),
          ({ theme }) => ({
            "&:hover": {
              backgroundColor: theme.color.green2
            },
            "&:active": {
              backgroundColor: theme.color.green3
            },
            "&:focus": {
              boxShadow: `0 0 0 2px ${rgba(theme.color.green6, 0.25)}`,
              transform: "translateZ(1px)"
            }
          })
        ],
        [
          ({ $appearance }) => $appearance === "danger" || $appearance === "error",
          ({ theme }) => ({
            "&:hover": {
              backgroundColor: theme.color.red2
            },
            "&:active": {
              backgroundColor: theme.color.red3
            },
            "&:focus": {
              boxShadow: `0 0 0 2px ${rgba(theme.color.red6, 0.25)}`,
              transform: "translateZ(1px)"
            }
          })
        ],
        [
          propEq("$appearance", "warning"),
          ({ theme }) => ({
            "&:hover": {
              backgroundColor: theme.color.yellow2
            },
            "&:active": {
              backgroundColor: theme.color.yellow3
            },
            "&:focus": {
              boxShadow: `0 0 0 2px ${rgba(theme.color.yellow6, 0.25)}`,
              transform: "translateZ(1px)"
            }
          })
        ],
        [
          stubTrue,
          ({ theme }) => ({
            "&:hover": {
              backgroundColor: theme.color.gray4
            },
            "&:active": {
              backgroundColor: theme.color.gray5
            },
            "&:focus": {
              boxShadow: `0 0 0 2px ${rgba("black", 0.05)}`
            }
          })
        ]
      ])
    ]
  ])
);
const PillText = styled("span")({
  overflow: "hidden",
  textOverflow: "ellipsis"
});
export {
  PillButton,
  PillText,
  PillWrapper
};
